var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-paginate" },
    [
      _c("c-select", {
        staticClass: "per-page",
        attrs: {
          placeholder: "",
          "form-label": "Itens por página",
          "data-cy": "items-per-page",
          value: _vm.per_page,
          options: _vm.perPageOptions,
          "allow-empty": false,
          searchable: false
        },
        on: { input: _vm.changePerPage }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "controls" },
        [
          _c("c-button", {
            staticClass: "button",
            attrs: {
              icon: "first",
              alternative: "",
              disabled: _vm.disablePrevButton || _vm.isFetching
            },
            on: {
              click: function($event) {
                return _vm.updatePaginate("first-page")
              }
            }
          }),
          _vm._v(" "),
          _c("c-button", {
            staticClass: "button",
            attrs: {
              icon: "previous",
              alternative: "",
              disabled: _vm.disablePrevButton || _vm.isFetching
            },
            on: {
              click: function($event) {
                return _vm.updatePaginate("previous-page")
              }
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "info" }, [
            _vm._v("\n      " + _vm._s(_vm.info) + "\n    ")
          ]),
          _vm._v(" "),
          _c("c-button", {
            staticClass: "button",
            attrs: {
              icon: "next",
              alternative: "",
              disabled: _vm.disableNextButton || _vm.isFetching
            },
            on: {
              click: function($event) {
                return _vm.updatePaginate("next-page")
              }
            }
          }),
          _vm._v(" "),
          _c("c-button", {
            staticClass: "button",
            attrs: {
              icon: "last",
              alternative: "",
              disabled: _vm.disableNextButton || _vm.isFetching
            },
            on: {
              click: function($event) {
                return _vm.updatePaginate("last-page")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e633d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e633d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CPaginate.vue
// module id = 93Cb
// module chunks = 1624